import React, { useEffect, useState } from 'react';

import cn from 'classnames';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { Input } from 'reactstrap';

import { getWalletConfirmationStatus } from 'services/walletConfirmationService';

import WalletStatusBadge from '../../Dashboard/WalletConfirm/WalletStatusBadge';
import { MCField } from '../../../components/mc';

import s from './Components.module.scss';

const CopyGlyph = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
    <rect x="5.25" y="5.25" width="8.5" height="8.5" rx="2" stroke="currentColor" strokeWidth="1.4" />
    <path
      d="M3.75 10.75H3A1.75 1.75 0 0 1 1.25 9V3A1.75 1.75 0 0 1 3 1.25h6A1.75 1.75 0 0 1 10.75 3v.75"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

// Read-only view of the payout address + its confirmation status. The address is set/changed
// ONLY by signing on the dashboard (self-custody flow) — never edited manually here.
const DefaultWalletChange = () => {
  const userWalletAddr = useSelector((state) => state.Profile.user.default_wallet_address ?? '');
  const [copied, setCopied] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(null);

  useEffect(() => {
    let alive = true;
    getWalletConfirmationStatus()
      .then((st) => {
        if (alive) setIsConfirmed(Boolean(st?.is_confirmed));
      })
      .catch(() => {
        /* non-fatal: badge just stays hidden */
      });
    return () => {
      alive = false;
    };
  }, []);

  async function copyWallet() {
    const value = (userWalletAddr || '').trim();
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      // clipboard unavailable — silently ignore (no state/data impact)
    }
  }

  return (
    <div className={s.walletBlock}>
      <MCField label={t('user_profile_default_wallet_address')}>
        <div className={s.walletRow}>
          <Input
            value={userWalletAddr}
            className={cn('auth-input', s.input, s.walletInput)}
            disabled
            readOnly
          />
          <button
            type="button"
            className={s.walletCopyBtn}
            onClick={copyWallet}
            aria-label={t('common_copy') || 'Copy'}
            title={copied ? t('common_copied') || 'Copied' : t('common_copy') || 'Copy'}>
            <CopyGlyph />
          </button>
        </div>
      </MCField>

      {isConfirmed !== null && (
        <div className="mt-2">
          <WalletStatusBadge isConfirmed={isConfirmed} />
        </div>
      )}
    </div>
  );
};

export default DefaultWalletChange;
